<template>
    <div class="trends-tag-list">
        <TrendsTag v-for="(tag, index) in tags" :key="`${tag.text}-${index}`" :href="tag.href" :text="tag.text" />
    </div>
</template>

<script setup lang="ts">
    import TrendsTag from '~/components/trends/TrendsTag.vue';

    defineProps<{tags: (typeof TrendsTag)['props'][]}>();
</script>

<style lang="scss">
    .trends-tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: var(--joy-core-spacing-2);
    }
</style>
